import { render, staticRenderFns } from "./InputList.vue?vue&type=template&id=1bc8ceb6&scoped=true&"
import script from "./InputList.vue?vue&type=script&lang=js&"
export * from "./InputList.vue?vue&type=script&lang=js&"
import style0 from "./InputList.vue?vue&type=style&index=0&id=1bc8ceb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8ceb6",
  null
  
)

export default component.exports